'use client';
import Chatbot from '@/components/chatbot';
import { CommerceModal } from '@/components/modal';
import { CommerceToast } from '@/components/toast';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { commerceJWT } from '@repo/ecommerce-api';
import { theme } from '@repo/ui';
import { getClientCookie, parseJwt, SendNavigatorData } from '@repo/utils';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import { Provider, useDispatch } from 'react-redux';
import { store } from './store';
import { pushUserdata, resetUserdata } from './userdataSlice';

const LoadUserData = () => {
  const dispatch = useDispatch();
  const token = getClientCookie('token-commerce');
  const decodedToken = parseJwt(token || '') as commerceJWT;
  const pathname = usePathname();

  useEffect(() => {
    if (decodedToken && pathname !== '/login') {
      dispatch(
        pushUserdata({
          isAuth: true,
          username: decodedToken.sub,
          role: decodedToken.role,
          ecommerce: decodedToken?.ecommerce,
          comercionombre: decodedToken?.comercionombre,
          comerciocodigo: decodedToken?.comerciocodigo,
        }),
      );
    } else {
      dispatch(resetUserdata());
    }
  }, [dispatch, decodedToken, pathname]);
  return <></>;
};

export function Providers({ children, nonce }: { children: React.ReactNode; nonce: string }) {
  useEffect(() => {
    SendNavigatorData({
      app: 'commerce',
    });
  }, []);
  return (
    <ThemeProvider theme={theme({ nonce })}>
      <CssBaseline />
      <Provider store={store}>
        <LoadUserData />
        <CommerceToast />
        <CommerceModal />
        {children}
        <Chatbot />
      </Provider>
    </ThemeProvider>
  );
}
